import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { getJsonData } from "Apis/utils";

export const MetrimonialContext = createContext();

export const MetrimonialContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [matrimonialData, setMatrimonialData] = useState([]);
  const [uploadImage, setUploadImage] = useState([]);
  const [maritalStatusData, setMaritalStatusData] = useState([]);

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  // Json Listing
  const jsonListing = async () => {
    let data = await getJsonData();
    if (data?.status === 200) {
      const maritalStatusOptions = data?.data?.data?.matrimonialMaritalStatusData?.map(
        (status) => ({
          label: status.label,
        })
      );
      setMaritalStatusData(maritalStatusOptions);
    }
  };

  return (
    <MetrimonialContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        matrimonialData,
        setMatrimonialData,
        uploadImage,
        setUploadImage,
        maritalStatusData,
        jsonListing,
      }}
    >
      {children}
    </MetrimonialContext.Provider>
  );
};

export default MetrimonialContextProvider;
MetrimonialContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
